const NewsLetterConfig = () => {
  const NewsLetterConfigData = {
    mailChimpApiKey: "6051dcd173371fad35b5f91d1ce47393-us8",
    title: "Join Our Newsletter",
    description:
      "Newslaundry wants to make news a service to the public, not to the advertisers. We believe those who make any effort sustainable, determine its direction.",
    subscriptionData: [
      {
        title: "Stop Press",
        description: "A weekly newsletter by Chitranshu Tewari to help you track the news media ecosystem and make sense of it. See the latest edition here ",
        mailChimplistId: "a2ab56c30d",
        id: "first"
      },
      {
        title: "NL Events",
        description: "Newslaundry Events: From The Media Rumble to NL Chats and webinars, updates and details on latest Newslaundry events",
        mailChimplistId: "3cf030021e",
        id: "second"
      },
      {
        title: "NL Digest",
        description:
          "A weekly guide to the best of our stories from our editors and reporters.",
        mailChimplistId: "c6b749d171",
        id: "third"
      },
      {
        title: "Highway On My Podcast",
        description:
          "A weekly plunge into trivia and behind-the-scenes moments from Rocky and Mayur’s travels across India with the latest HOMP episode.",
        mailChimplistId: "96bacfe85d",
        id: "fourth"
      },
      {
        title: "न्यूज़लॉन्ड्री डाक",
        description:
          "न्यूज़लॉन्ड्री हिन्दी के साप्ताहिक संपादकीय, चुनिंदा बेहतरीन रिपोर्ट्स, टिप्पणियां और मीडिया की स्वस्थ आलोचनाएं. शार्दूल कात्यायन की कलम से.",
        mailChimplistId: "aa2c780e6c",
        id: "fifth"
      },
      {
        title: "Mic Drop",
        description:
          "A weekly capsule of our podcasts, part of some of India's most-followed podcasts on media, politics, pop culture, food and more. ",
        mailChimplistId: "82e2052fcc",
        id: "sixth"
      }

    ]
  };

  return NewsLetterConfigData;
};

module.exports = NewsLetterConfig;
